<template>
  <div class="comp-container">
    <div
      class="arrow left-arrow"
      :class="{ disabled: arrowStatus[0] == 0 }"
      @click="move(-1)"
    ></div>
    <div
      class="item-List"
      ref="list"
      :style="{ overflowX: moveing ? 'hidden' : 'auto' }"
      @scroll="calcScrollLeft"
    >
      <div class="scroll-box" ref="scrollBox">
        <iframe ref="helper" class="helper"></iframe>
        <slot></slot>
      </div>
    </div>
    <div
      class="arrow right-arrow"
      :class="{ disabled: arrowStatus[1] == 0 }"
      @click="move(1)"
    ></div>
  </div>
</template>

<script>
export default {
  name: "lrSlideBox",
  props: {},
  data() {
    return {
      moveing: false,
      moveLeft: 0,
      moveTimeLength: 1,

      boxStyle: {
        width: 0,
        fullWidth: 0,
        scrollLeft: 0,
      },
    };
  },
  computed: {
    arrowStatus() {
      return [
        this.boxStyle.scrollLeft <= 0 ? 0 : 1,
        this.boxStyle.scrollLeft + this.boxStyle.width >=
        this.boxStyle.fullWidth
          ? 0
          : 1,
      ];
    },
  },
  watch: {},
  methods: {
    calcScrollLeft() {
      this.boxStyle.scrollLeft = this.$refs.list.scrollLeft;
    },
    calcBoxStyle() {
      this.boxStyle.width = this.$refs.list.clientWidth;
      this.boxStyle.fullWidth = this.$refs.list.scrollWidth;
      this.calcScrollLeft();
    },
    move(way = 1) {
      if (this.moveing) {
        return;
      }
      let width = this.boxStyle.width;
      let fullWidth = this.boxStyle.fullWidth;
      let scrollLeft = this.boxStyle.scrollLeft;
      let move = (width / 2) * way;

      if (move > fullWidth - scrollLeft - width) {
        move = fullWidth - scrollLeft - width + 1; //解决小数点偏差
      } else if (move < -scrollLeft) {
        move = -scrollLeft;
      } else {
      }

      this.$refs.list.scrollLeft += move;
      this.moveLeft = move;
      this.$refs.scrollBox.style.transform = `translateX(${this.moveLeft}px)`;
      this.$refs.scrollBox.style.transition = `${
        this.moveing ? this.moveTimeLength : 0
      }s`;
      this.$nextTick(() => {
        // requestAnimationFrame(() => {
        this.moveing = true;
        this.moveLeft = 0;
        this.$refs.scrollBox.style.transform = `translateX(${this.moveLeft}px)`;
        this.$refs.scrollBox.style.transition = `${
          this.moveing ? this.moveTimeLength : 0
        }s`;
        setTimeout(() => {
          this.moveing = false;
        }, this.moveTimeLength * 1000);
        // });
      });
      // setTimeout(() => {
      //   this.moveing = true;
      //   this.moveLeft = 0;
      //   setTimeout(() => {
      //     this.moveing = false;
      //   }, this.moveTimeLength * 1000);
      // }, 0);
    },
  },
  components: {},
  mounted() {
    this.$refs.helper.contentWindow.addEventListener(
      "resize",
      this.calcBoxStyle
    );
    this.calcBoxStyle();
  },
  created() {},
  beforeDestroy() {
    this.$refs.helper &&
      this.$refs.helper.contentWindow &&
      this.$refs.helper.contentWindow.removeEventListener("resize");
  },
};
</script>

  <style lang="scss" scoped>
.comp-container {
  display: flex;
  align-items: center;

  .arrow {
    $size: 0.54rem;
    width: $size;
    height: $size;
    margin: 0.1rem;
    background-image: url(./imgs/arrow-btn.png);
    background-size: 100% 100%;

    &.disabled {
      filter: grayscale(1);
    }
  }
  .left-arrow {
    transform: scaleX(-1);
  }
  .item-List {
    // border: 2px solid #f00;
    flex: 1;
    width: 0;
    // max-height: 100%;
    // overflow-x: auto;
    // display: flex;
    .scroll-box {
      width: fit-content;
      position: relative;

      .helper {
        position: absolute;
        padding: 0;
        margin: 0;
        border: 0;
        height: 0;
        width: 100%;
      }
    }
  }
}
</style>
